import React from 'react';
export const AdContext = React.createContext({});
AdContext.displayName = 'AdContext';
